import React, {useState, useEffect} from "react";
import FormModal from "../FormModal";
import useStyles from './styles';

import Separator from "./Separator";
import Info from "./Info";
import Chat from "./Chat";

import Button from "./Button";

import ConfirmDialog from "./ConfirmDialog";
import { fancyTimeFormat } from "../../utils/date";
import { prettyTime } from "../../utils/date";

const CallMonitor  = ({
  monitorControl,
  setMonitorOpened,
  schedulingData,
  onCalled,
  setUpdateDriverPrimaryPhone,
  setUpdateDriverSecondaryPhone,
  getCallMessages
}) => {
    const [popup, setPopup] = useState({show: false});
    const handleOnClose = () => setMonitorOpened(false);
    const classes = useStyles();
    const schedulingInfo = {
        id: schedulingData?.id,
        delay: schedulingData?.delay_max_minutes,
        schedulingStatus: schedulingData?.id_scheduling_status,
        driver: {
            name: `${schedulingData?.driver_name}`,
            plate: `${schedulingData?.truck_plate}`,
            phone1: (!!schedulingData?.driver_phone_number) ? `${schedulingData?.driver_phone_number}`.slice(3,14) : "",
            phone2: (!!schedulingData?.driver_additional_phone_number) ? `${schedulingData?.driver_additional_phone_number}`.slice(3,14) : ""
        }
    };

    const messages = schedulingData?.schedulingMessages;

    const [editMode1, setEditMode1] = useState(false);
    const [editMode2, setEditMode2] = useState(false);
  
    const metadata  = schedulingData?.metadata;
    
    const { lastCalledTime, calledTimeout, lastBackendSyncTime, backendSyncTimeout } = metadata || {};

    const handleRefreshChat = () => {
      getCallMessages(schedulingInfo?.id);
    };

    const closePopup = () => {
        setPopup({...{ show:false }, popup})
    }

    const handleUpdatePhone1 = async (phone) => {
      setEditMode1(false);
      const res = await setUpdateDriverPrimaryPhone(
        {
          id: schedulingInfo?.id,
          body: {
            phone_number: `+55${phone}`
          }
        }
      );

      if(res?.success === false) {
        setEditMode1(true);
      }
    };

    const handleUpdatePhone2 = async (phone) => {

      setEditMode2(false);
      const phoneString = !!phone ? `+55${phone}` : '';

      const res = await setUpdateDriverSecondaryPhone(
        {
          id: schedulingInfo?.id,
          body: {
            phone_number: phoneString
          }
        }
      );

      if(res?.success === false) {
        setEditMode2(true);
      }
    };

    const handleSubmit = () => {
        setPopup({
            show: true,
            type: 'question',
            message: `Deseja realmente chamar o agendamento <br/><strong>${schedulingInfo?.id}</strong>?`,
            handlerRefuse: () => closePopup(),
            handlerAccept: () => {
                onCalled(schedulingInfo?.id);
                closePopup();
            }
        });
    }

    const reverseCounter = (startTime, maxTimeout, counterCallback, timesUpCallback = null) => {
      const targetTime = startTime + (1000 * maxTimeout);
      const x = setInterval(() => {
        const now = new Date().getTime();
        const distance = Math.round((targetTime - now) / 1000);
        counterCallback(distance);
        if (distance < 1) {
          clearInterval(x);
          counterCallback(0);
          if(!!timesUpCallback){
            timesUpCallback();
          }
        }
      }, 1000)
      return x;
    }
  
    const [callButtonDisabled, setCallButtonDisabled] = useState(true);
    const [counterCall, setCounterCall] = useState(1);
    const [counterSyncBackend, setCounterSyncBackend] = useState(null);

    const callButtonTimeout = calledTimeout ?? 30; //segundos
    
    const { id: schedulingId } = schedulingData || {};

    useEffect(() => {
      if (monitorControl && !!schedulingId){
        getCallMessages(schedulingId);   
      }

      if(!monitorControl)
      {
        setCounterCall(1);
      }
    }, [monitorControl, schedulingId, getCallMessages]);

    useEffect(() => {
      setCallButtonDisabled(counterCall > 0);
    }, [counterCall, setCallButtonDisabled]);

    useEffect(() => {
      if(monitorControl && !!lastBackendSyncTime && !!backendSyncTimeout){
        const interval = reverseCounter(Number(lastBackendSyncTime), (backendSyncTimeout+1), setCounterSyncBackend, ()=> getCallMessages(schedulingId));     
        return () => clearInterval(interval);
      }
    }, [monitorControl,  schedulingId, getCallMessages, lastBackendSyncTime, backendSyncTimeout, setCounterSyncBackend]);

    useEffect(() => {
      const interval = reverseCounter(Number(lastCalledTime), callButtonTimeout, setCounterCall);    
      if(!monitorControl){
        clearInterval(interval)
      } 
      return () => clearInterval(interval);

    }, [monitorControl, callButtonTimeout, lastCalledTime]);

    return (
        <FormModal
            title=""
            open={monitorControl}
            handleClose={handleOnClose}
            topBorder = {false}
            id={`call-monitor-form-modal-id`}
            data-cy={`call-monitor-form-modal-data-cy`}
            disableBorder={true}
        >
            <div className={classes.title} id={`call-monitoring-text-id`} data-cy={`call-monitoring-text-data-cy`}>
                Monitoramento de Chamadas
            </div>
            <Separator />
            <Info
                data={schedulingInfo}
                handleRefreshChat={handleRefreshChat}
                handleUpdatePhone1={handleUpdatePhone1}
                handleUpdatePhone2={handleUpdatePhone2}
                onEditMode1={editMode1}
                onEditMode2={editMode2}
                id={`call-monitor-info-id`}
                data-cy={`call-monitor-info-id`}
            />
            <div style={{display: 'flex', fontWeight: '700',color: '#666666', fontSize: '0.9rem'}}>
             
              <div id={`chat-timeout-update`} data-cy={`chat-timeout-update`} style={{width: '100%', height: '21px', textAlign: 'right'}}>
                <span>{ counterSyncBackend > 0 && `Chat atualizado às ${prettyTime(lastBackendSyncTime)}, nova atualização em cerca de ${fancyTimeFormat(counterSyncBackend)}` }</span>
              </div>
            </div>
            <Chat messages={messages} driverName={schedulingInfo?.driver?.name} delay={schedulingInfo?.delay} id={`call-monitor-chat-id`} data-cy={`call-monitor-chat-data-cy`}/>
            <div className={classes.footer}>
                <div className={classes.note} id={`timeout-messages`} data-cy={`timeout-messages`}>
                  <span id={`timeout-message-call`} data-cy={`timeout-message-call`}>
                    { counterCall > 1 && `Você precisa aguardar ${fancyTimeFormat(counterCall)} para chamar o motorista novamente`}
                  </span>
                </div>
                <Button
                    title={(schedulingInfo.schedulingStatus !== 7) ? `Chamar` : `Chamar Novamente`}
                    disabled={callButtonDisabled}
                    handleSubmit={handleSubmit}
                    id={`call-monitor-call-button-id`}
                    data-cy={`call-monitor-call-button-data-cy`}
                />
            </div>
            <ConfirmDialog
                isOpen={popup?.show}
                type={popup?.type}
                message={popup?.message}
                handlerRefuse={popup?.handlerRefuse}
                handlerAccept={popup?.handlerAccept}
                id={`call-monitor-confirm-dialog-id`}
                data-cy={`call-monitor-confirm-dialog-data-cy`}
            />
        </FormModal>
    );
};

export default CallMonitor;
